

/**
 * @deprecated Decision was to switch this off, 27 nov 2025
 * Check if an item is biogenic -- which is reported as Scope 1 emissions but not included in the Scope 1 total.
 * See CarbonAccountingUtils.java
 * @param item 
 * @returns {boolean}
 */
export function isBiogenic(item) {
	if (true) return false;
	if ( ! item) return false;
	const code = item.code || item.measure?.code;
	const name = item.name || item.measure?.name;
	const biocode = code?.toLowerCase().startsWith("bio");
	const bioname = name?.toLowerCase().startsWith("bio");
	return biocode || bioname;
}
